import { memo, PropsWithChildren } from 'react';

interface Props {
    className?: string;
    width: '4' | '6' | '8' | '12'; // '4 | 6 | 8 | 12'
}

const GridBlock: React.FC<PropsWithChildren<Props>> = ({
    children,
    className = '',
    width = '12'
}) => {

    let widthClass = ''
    if ('4' === width) { widthClass = 'col-span-1 lg:col-span-4' }
    if ('6' === width) { widthClass = 'col-span-1 lg:col-span-6' }
    if ('8' === width) { widthClass = 'col-span-1 lg:col-span-8' }
    if ('12' === width) { widthClass = 'col-span-1 lg:col-span-12' }

    return (
        <div className={`${widthClass} ${className}`}>
            {children}
        </div>
    )
}

export default memo(GridBlock)